export const companyConstants = {
  //create company
  CREATE_COMPANY_HIRING_MANAGER_ACTION_REQUEST:
    "CREATE_COMPANY_HIRING_MANAGER_ACTION_REQUEST",
  CREATE_COMPANY_HIRING_MANAGER_ACTION_SUCCESS:
    "CREATE_COMPANY_HIRING_MANAGER_ACTION_SUCCESS",
  CREATE_COMPANY_HIRING_MANAGER_ACTION_FAILURE:
    "CREATE_COMPANY_HIRING_MANAGER_ACTION_FAILURE",

  //get company details
  GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST",
  GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE",

  //update company details
  UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST:
    "UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST",
  UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
    "UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS",
  UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE:
    "UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE",
};